export interface Card {
  title: string;
  subtitle: string;
  link: string;
  icon?: string;
  dynamicTitle?: string | number;
}
